const internals = {
  x_api_key: String(process.env.VUE_APP_X_API_KEY),
  key: String(process.env.VUE_APP_KEY),
  url_api: String(process.env.VUE_APP_API_URL),
  tecfin_url: String(process.env.VUE_APP_TECFIN_URL),
  googleKey: String(process.env.VUE_APP_GOOGLE_KEY),
};

Object.freeze(internals);

export default internals;
